import React, {Component} from 'react';
import {connect} from "react-redux";
import {url_server} from "../../../constants/server";
import {setDisp, setFetchState} from "../../../actions";

class CalendarNav extends Component {

  handleUpdateClick = async () => {

    // marcar estado de fetching en true
    this.props.setFetchState({
      fetchingState: true
    });

    // get data from server
    const data = await this.getDataFromServer();

    // marcar estado de fetching en false
    this.props.setFetchState({
      fetchingState: false
    });

    if (data) {
      // disparar accion
      this.props.setDisp(data);
    }
    else {
      this.props.setServiceState('inactive');
    }

  };

  async getDataFromServer() {

    let data;

    try {
      const res = await fetch(`${url_server}/boleto/disponibilidad`, {
        method: 'post',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({
          "idRuta": this.props.store.idRuta,
          "mes": parseInt(this.props.store.mes) + 1, // el mes es del 1 al 12 en el server
          "anio": this.props.store.anio
        })
      });

      data = await res.json();

      return data;

    } catch (e) {
      console.error(e)
    }

  }

  render() {

    return (
      <div className="calendar-nav">

        <span id="btn-refresh" className="btn-sup" onClick={this.handleUpdateClick} >
          <i className="material-icons">refresh</i>
        </span>
        {/* <div className="mdl-tooltip" htmlFor="btn-refresh">Actualizar</div> */}

        {/*<span id="btn-fullscreen" className="btn-sup" onClick={() => {}} >*/}
        {/*  <i className="material-icons">aspect_ratio</i>*/}
        {/*</span>*/}
        {/* <div className="mdl-tooltip" htmlFor="btn-fullscreen">Pantalla Completa</div> */}
      </div>
    );

  }

}

const mapStateToProps = store => ({
  store
});

const mapDispatchToProps = dispatch => ({
  setDisp: value => dispatch(setDisp(value)),
  setFetchState: value => dispatch(setFetchState(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CalendarNav);
